import styled, { css } from 'styled-components';
import ChildrenInner from 'gatsby-theme-menus/src/components/nav/list-nav/children-inner';

export default styled(ChildrenInner)`
  ${({ $hasColumn }) => !$hasColumn && css`
    background-color: ${({ theme }) => theme.backgroundColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    padding: .5rem 0;
  `}
`;
